import styled, { css } from 'styled-components'
import { Box } from '../../../../shared_components/UI/Box'

export const poolsContainerCommonStyles = css`
  display: grid;
  grid-template-columns: 26% 200px 1fr 120px 140px 140px 100px;
  align-items: center;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`

export const PoolContainer = styled.div<{ hover?: string }>`
  transition: 0.3s ease-in-out;
  position: relative;
  padding-top: 16px;
  padding-bottom: 16px;

  ${poolsContainerCommonStyles}

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 0px;
    background: #c4c4c4;
    opacity: 0.4;
  }
  :hover {
    cursor: pointer;
    background: ${({ theme }) => theme.colors.rewardTabBorder};
  }
`

export const MobilePoolCard = styled(Box)`
  display: none;
  @media screen and (max-width: 1000px) {
    display: block;
    flex: 1;
    min-height: 284px;
    width: 100%;
    padding-bottom: 32px;
    margin: 16px auto;
    border-bottom: 1px solid #3f3957;
  }
`

export const TokenName = styled.h4`
  /* font-family: 'Space Grotesk'; */
  font-weight: 600;
  font-size: 20px;
  line-height: 23px;
  @media screen and (min-width: 600px) {
    font-size: 16px;
    line-height: 20px;
  }
`

export const TokenSymbol = styled.h5`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  text-transform: uppercase;
  opacity: 0.6;
  @media screen and (min-width: 600px) {
    font-family: 'Space Grotesk';
    font-style: normal;
    margin-top: 4px;
    font-size: 12px;
    line-height: 15px;
    opacity: 0.5;
    text-transform: uppercase;
  }
`

export const Label = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  opacity: 0.6;
  margin-bottom: 8px;
`

export const ThinLabel = styled.span`
  font-family: 'Space Grotesk';
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
`

export const Info = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  @media screen and (min-width: 1000px) {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
  }
`

export const InfoBlock = styled(Box)`
  margin: 24px 0 0;
`

export const NameAndSymnol = styled(Box)`
  margin-left: 16px;
`

export const ProgressPct = styled.span<{ period: string; isDesktop?: boolean }>`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  margin-top: 8px;
  font-family: 'Space Grotesk';

  ${({ isDesktop }) =>
    isDesktop &&
    css`
      font-size: 16px;
      line-height: 20px;
      margin-left: 20px;
      min-width: 49px;
      margin-right: 20px;
      margin-top: 0;
      text-align: right;
    `}
`

export const PeriodLabel = styled.span<{ period: string }>`
  align-self: center;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: ${({ period, theme }) =>
    period === 'upcoming'
      ? theme.colors.brandPrimary
      : period === 'private' || period === 'public' || period === 'active'
      ? theme.colors.brandSecondary
      : theme.semantics.zap.surface.primary};
  opacity: ${({ period }) => (period === 'completed' ? '0.3' : '1')};
`
